module.exports = __webpack_public_path__ + "static/media/[猫咪]@2x.e4a9b1e8.png";